// packages block
import { useHistory } from "react-router";
import ReactDropzone from "react-dropzone";
import { useTranslation } from "react-i18next";
import React, { useState, useReducer } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import NotificationsIcon from "@material-ui/icons/Notifications";
// common block
import "./style.css";
import { preaddStyles } from "../../../../components/dialogs/styles";
import { FormButton } from "../../../../components/form";
import { SearchInput } from "../../../../components/form/searchInput";
// constants, theme, utils and api block
import { setAlert } from "../../../../redux/reducers/alert";
import { BLUE_EIGHT, ORANGE_TWO, WHITE } from "../../../../theme";
import { useEffect } from "react";
import { ArrowForward } from "@material-ui/icons";
import {
  BASE_URL,
  CHECK_SCHOOL_SYNC_ERP_STATUS,
  SYNC_ERP_FEE_WITH_ERP,
  SYNC_ERP_STUDENTS,
} from "../../../../util/constants";
import axios from "axios";
import { setLoadingForAllSyncButtons } from "../../../../redux/reducers/allSyncButtonsLoader";
import { Box, CircularProgress } from "@material-ui/core";
import { Button } from "react-bootstrap";

const useStyles = makeStyles((theme) => ({
  formControl: {
    height: 35,
    minWidth: 150,
  },
  buttonBackground: {
    width: "10vw",
    color: { WHITE },
    backgroundColor: BLUE_EIGHT,
    border: `1px solid ${BLUE_EIGHT}`,
    borderRadius: 15,
    height: 40,
  },
}));

export const TableHeader = ({
  handleFileUpload = () => {},
  handleSearching,
  openNotifyParentDialog,
  open,
  selectedIds,
  setLoading,
  schoolId,
  handleUpdate,
}) => {
  const [file, setFile] = useState(null);

  const { allSyncButtonsLoader } = useSelector(
    (state) => state.loadingForAllSyncButtons
  );
  const { erpSchoolExists } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  let local = JSON.parse(localStorage.getItem("notify"));
  local = local || [];
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const fileUploadClasses = preaddStyles();
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );
  const syncFeeWithErp = async () => {
    dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: true }));

    const rawRes = await fetch(
      BASE_URL + "/" + SYNC_ERP_FEE_WITH_ERP + `?schoolId=${schoolId}`
    );
    const response = await rawRes.json();
    if (response.status) {
      showSuccessAlert("Students synced successfully");
      await axios.get(
        BASE_URL + "/" + SYNC_ERP_STUDENTS + `?schoolId=${schoolId}`
      );
      window.location.reload();
    } else {
      showErrorAlert("Failed to sync students");
      dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
    }
    dispatch(setLoadingForAllSyncButtons({ allSyncButtonsLoader: false }));
  };
  const { token } = useSelector((state) => state.user);
  const handleChange = (prop) => (event) => {
    handleSearching(event.target.value, token);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };

  const uploadFile = (acceptedFiles) => {
    let fileSize = acceptedFiles[0].size / 1024 / 1024;
    if (fileSize < 10) {
      if (acceptedFiles.length > 0) setFile(acceptedFiles[0]);
    } else {
      showErrorAlert("Your CSV must be 10MB or greater than 10MB, Try again");
    }
  };
  useEffect(() => {
    axios
      .get(
        BASE_URL + "/" + CHECK_SCHOOL_SYNC_ERP_STATUS + `?schoolId=${schoolId}`
      )
      .then((res) => {
        dispatch(
          setLoadingForAllSyncButtons({
            allSyncButtonsLoader: Boolean(res.data.isProcessing),
          })
        );
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }, []);
  const handleUpload = async () => {
    if (file.type === "application/vnd.ms-excel") {
      handleFileUpload(file);
    } else {
      handleFileUpload(file);
    }
  };

  useEffect(() => {
    if (!open) setFile(null);
  }, [open]);

  return (
    <div className="table-header student-popup invoice-table-header">
      <div className="left-column">
        <div className="student_SearchBar">
          <SearchInput
            searchIcon={true}
            error={searchError}
            value={search}
            onChange={handleChange}
            label={t("text_search_by_student_id_or_student_name")}
            name="search"
            height={40}
          />
        </div>
      </div>

      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <div
          className={fileUploadClasses.csvDropZoneContainer}
          style={{ padding: "0px 10px 0px 10px" }}
        >
          {erpSchoolExists ? (
            <div>
              <FormButton
                width={"10vw"}
                height={40}
                borderColor={BLUE_EIGHT}
                titleColor={BLUE_EIGHT}
                hoverTitleColor={WHITE}
                hoverBorderColor={BLUE_EIGHT}
                backgroundColor={WHITE}
                hoverBackgroundColor={BLUE_EIGHT}
                borderTopRightRadius={15}
                borderTopLeftRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                title={t("text_sync_fee")}
                style={{
                  textTransform: "none",
                  fontSize: "0.8vw",
                  fontWeight: "700",
                  padding: 0,
                }}
                onClickHandler={() => syncFeeWithErp()}
                disabled={true}
                loading={allSyncButtonsLoader}
                loaderText={`${t("text_syncing")}...`}
              />
            </div>
          ) : (
            <ReactDropzone onDrop={uploadFile} multiple={false}>
              {({ getRootProps, getInputProps }) => (
                <section>
                  <div {...getRootProps()}>
                    <input {...getInputProps()} accept=".csv" />
                    {file === null && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {allSyncButtonsLoader ? (
                          <Button
                            className={classes.buttonBackground}
                            variant="outlined"
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                          >
                            <Box
                              display="flex"
                              justifyContent="center"
                              alignItems="center"
                              width="100%"
                              height="100%"
                            >
                              <CircularProgress
                                size={20}
                                sx={{ color: "white", mx: 1, width: "50%" }}
                              />
                              <span
                                style={{
                                  color: "white",
                                  textTransform: "capitalize",
                                  width: "100%",
                                }}
                                component="span"
                              >
                                {`${t("text_syncing")}...`}
                              </span>
                            </Box>
                          </Button>
                        ) : (
                          <div className={classes.csvDetail}>
                            <div
                              style={{
                                cursor: "pointer",
                                borderRadius: 15,
                                textTransform: "none",
                                fontSize: "0.8vw",
                                fontWeight: "700",
                                borderColor: BLUE_EIGHT,
                                color: BLUE_EIGHT,
                                backgroundColor: WHITE,
                                height: 40,
                                width: "10vw",
                                border: `1px solid  ${BLUE_EIGHT}`,
                                display: "flex",
                                textAlign: "center",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={(event) => handleUpdate(event)}
                            >
                              {t("text_update_bulk")}
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </section>
              )}
            </ReactDropzone>
          )}
          {file && (
            <FormButton
              style={{
                textTransform: "none",
                fontSize: "0.8vw",
                fontWeight: "700",
              }}
              title={t("text_update_balance")}
              width={"10vw"}
              height={40}
              startIcon={<ArrowForward />}
              borderColor={BLUE_EIGHT}
              titleColor={BLUE_EIGHT}
              hoverTitleColor={WHITE}
              hoverBorderColor={BLUE_EIGHT}
              backgroundColor={WHITE}
              hoverBackgroundColor={BLUE_EIGHT}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              onClickHandler={handleUpload}
            />
          )}
        </div>

        <div>
          <FormButton
            width={"10vw"}
            height={40}
            borderColor={BLUE_EIGHT}
            titleColor={BLUE_EIGHT}
            hoverTitleColor={WHITE}
            hoverBorderColor={BLUE_EIGHT}
            backgroundColor={WHITE}
            hoverBackgroundColor={BLUE_EIGHT}
            borderTopRightRadius={15}
            borderTopLeftRadius={15}
            borderBottomLeftRadius={15}
            borderBottomRightRadius={15}
            disabled={true}
            overRideButtonCheck={!selectedIds.length > 0}
            title={t("text_notify_parents")}
            onClickHandler={openNotifyParentDialog}
            startIcon={<NotificationsIcon style={{ color: "#fbd62f" }} />}
            style={{
              textTransform: "none",
              fontSize: "0.8vw",
              fontWeight: "700",
            }}
          />
        </div>
      </div>
    </div>
  );
};
